module.exports = __webpack_public_path__ + "img/volume-mute.4d9883c0.svg";